var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";
import History from "@irati/utils/history";
import ContentColumns from "./Content/ContentColumns";
import Title from "./Title";
import companyNewsToRows from "./utils/companyNewsToRows";
import HomePageRow from "../HomePageRow";
import { isRowEmpty } from "./utils/isRowEmpty";
import { HOMEPAGE_TOUR_PREFIX } from "../../../tour";
import Empty from "./Empty";
var HomepageTiles = /** @class */ (function (_super) {
    __extends(HomepageTiles, _super);
    function HomepageTiles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (openModal) {
            History.push({
                pathname: "/home/edit",
                state: { openModal: openModal }
            });
        };
        return _this;
    }
    HomepageTiles.prototype.render = function () {
        var _this = this;
        var _a = this.props, companyNews = _a.companyNews, id = _a.id, pageView = _a.pageView, isAdmin = _a.isAdmin;
        var rows = companyNewsToRows(companyNews);
        var filteredRowsWithContent = rows.filter(function (tiles) { return !isRowEmpty(tiles); });
        var areFilteredRowsEmpty = filteredRowsWithContent.length === 0;
        if (areFilteredRowsEmpty && !isAdmin) {
            return null;
        }
        return (React.createElement(HomePageRow, { id: id, "data-tour": HOMEPAGE_TOUR_PREFIX + "-step02", isEditRowView: false },
            React.createElement(Col, { xs: 12 },
                React.createElement(Title, { onClickEdit: function () { return _this.handleClick(areFilteredRowsEmpty); }, isAdmin: !!isAdmin }),
                areFilteredRowsEmpty && React.createElement(Empty, { onClick: function () { return _this.handleClick(true); } }),
                filteredRowsWithContent.map(function (companyNewsRow, i) { return (React.createElement(ContentColumns, { companyNewsRow: companyNewsRow, pageView: pageView, key: i })); }))));
    };
    HomepageTiles.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return HomepageTiles;
}(Component));
export default HomepageTiles;
